<template>
  <SectionSplit class="SectionPresentation reverse" src="../../assets/landing-finances/presentation.jpg">
    <h3>
      {{ $t('title') }}
    </h3>
    <h4 class="subtitle">
      {{ $t('subtitle') }}
    </h4>
    <p v-for="(paragraph, index) in $t('paragraphs')" :key="index">
      {{ paragraph }}
    </p>
    <a class="Btn lg" :href="registerLink" target="_blank">
      {{ $t('register') }}
    </a>
  </SectionSplit>
</template>

<script>
import SectionSplit from 'views/components/SectionSplit'
import { getters } from 'views/utils'

export default {
  components: { SectionSplit },
  data() {
    return {
      registerLinkLt: 'https://us06web.zoom.us/webinar/register/WN_moXTMxI1RQyO8Lk12zLqkQ#/registration',
      registerLinkEn: 'https://us06web.zoom.us/webinar/register/WN_t110AB-DTqSlklXVXRnPzw#/registration',
    }
  },
  computed: {
    registerLink() {
      return this.locale === 'lt'
        ? this.registerLinkLt
        : this.registerLinkEn
    },
    ...getters(),
  },
}
</script>

<style lang="scss">
.SectionPresentation {
  min-height: 60vh;
  @include lg {
    flex-direction: row;
    min-height: 60vh;
  }

  .subtitle {
    font-weight: $medium;
    margin-bottom: 2rem;
  }

  p {
    color: $black;
    font-size: $h5;
    line-height: 1rem;
    white-space: preserve-breaks;

    &:last-of-type {
      line-height: 1.5rem;
    }
  }

  .image {
    display: block;
    height: 30vh;
    @include lg {
      height: 60vh;
    }

    > img {
      height: 100%;
      object-fit: cover;
      object-position: top;
      width: 100%;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Project presentation",
    "subtitle": "8th November, 10AM (EET)",
    "paragraphs": [
      "Zoom",
      "Deividas Varabauskas \nSun Investment Group CEO"
    ],
    "register": "Register"
  },
  "lt": {
    "title": "Projekto pristatymas",
    "subtitle": "Lapkričio 7 d. 10:00",
    "paragraphs": [
      "Zoom platformoje",
      "Deividas Varabauskas \n„Sun Investment Group“ CEO"
    ],
    "register": "Registruotis"
  }
}
</i18n>
